"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageViewEvent = void 0;
const DefaultPagesEventNames_1 = require("./DefaultPagesEventNames");
/**
 * A Pages PageView Event
 *
 * @public
 */
exports.PageViewEvent = {
    eventType: DefaultPagesEventNames_1.DefaultPagesEventNames.PageView,
};
//# sourceMappingURL=PageViewEvent.js.map